 <ngx-dynamic-hooks #hooksEl class="RenderMath" [parsers]="dynamicComponents" [content]="questionText" [context]="dynamicContext" [options]="dynamicOptions"></ngx-dynamic-hooks>



